import React from "react";
import { Affix } from "antd";
import { App } from "context/AppContext";
import "./index.css";

function TxnDate() {
  const { collapsed, txnDate } = App();

  return <Affix offsetBottom={48}>{!collapsed && <div className="txn-date">{txnDate}</div>}</Affix>;
}

export default TxnDate;
